import { Logger, LoggingService } from 'ionic-logging-service';

import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';
import { Network } from '@capacitor/network';
import { Platform } from '@ionic/angular';

import packageJson from '../../../../../package.json';
import { CacheService } from './cache.service';
import { ConfigService } from './config.service';

@Injectable({ providedIn: 'root' })
export class LoggerService {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(
		private readonly loggingService: LoggingService,
		private readonly env: ConfigService,
		private readonly cache: CacheService,
		private readonly platform: Platform
	) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - getLogger
	 **-------------------------------------------------------------------------------------
	 */
	public getLogger(loggerName): Logger {
		const name = `VQUIP:${loggerName}`.toUpperCase();
		const l = this.loggingService.getLogger(name);
		if (!this.platform.is('capacitor')) return l;
		this.loggingService.configure({
			logLevels: [
				{
					loggerName: name,
					logLevel: 'INFO',
				},
			],
			ajaxAppender: {
				url: `${this.env.get<string>('loggingEndPoint')}/vquip`,
				threshold: 'ALL',
				batchSize: 20,
				timerInterval: 5000,
			},
		});
		const original = this.loggingService.getLogger(name);
		l.info = (message, args) => {
			Promise.all(
				[
					Device.getInfo(),
					Device.getBatteryInfo(),
					this.cache.get('secure:company_id'),
					Network.getStatus(),
				].map(p => p.catch(e => e))
			).then(([deviceInfo, batteryInfo, companyId, networkStatus]) => {
				const _args = Array.isArray(args) ? args : [args];
				const version = packageJson.version;
				original.info(message, [
					..._args,
					{ deviceInfo, version, batteryInfo, companyId, networkStatus },
				]);
			});
		};
		l.error = (message, args) => {
			// Promise.all(
			// 	[
			// 		Device.getInfo(),
			// 		Device.getBatteryInfo(),
			// 		this.cache.get('secure:company_id'),
			// 		Network.getStatus(),
			// 	].map(p => p.catch(e => e))
			// ).then(([deviceInfo, batteryInfo, companyId, networkStatus]) => {
			// 	const version = packageJson.version;
			// 	original.error(message, [
			// 		{ error: args },
			// 		{ deviceInfo, version, batteryInfo, companyId, networkStatus },
			// 	]);
			// });
		};
		return l;
	}
}
